import { EnumCouponError } from "../enums/EnumCouponError";
import { JsonCoupon } from "../json-data-types/JsonCoupon";
import { RequestMaker } from "./RequestMaker";


const filename = 'ServerCoupons'
export module ServerCoupons{


    export async function getAsync(code:string, email?:string, phone?:string){
        const result = await RequestMaker.sendWebsocketJsonRequestAsync<JsonCoupon>({
            query: 'coupon-get',
            params: {code, email, phone}
        }, filename)
        return result
    }

    export async function applyCouponToAnonymousBasketAsync(p:{couponCode:string, couponCodesInBasket:string[], quantityByJsonBasketProductInfo?:any[]}){
        const result = await RequestMaker.sendWebsocketJsonRequestAsync({
            query: 'basket-apply-coupon-for-anonymous',
            params: p
        }, filename)
        return result as JsonCoupon
    }

    export function getErrorMessageForCouponError(error:EnumCouponError|string){
        if(error.startsWith('Промокод')) return error // Промокод ${coupon.code} нельзя использовать вместе с другими промокодами
        switch (error) {
            case EnumCouponError.Unpublished:
            case EnumCouponError.Outdated:
            case EnumCouponError.BadUserId:
            case EnumCouponError.BadUserType:
                case EnumCouponError.NotFound:
                return 'Промокод не найден'
            case EnumCouponError.AlreadyUsedByUserId:
            case EnumCouponError.AlreadyUsedByPhoneOrEmail:
                return 'Промокод уже использован'
            case EnumCouponError.AlreadyApplied:
                return 'Промокод уже применен'
            case EnumCouponError.ZeroDiscount:
            case EnumCouponError.EmptyCode:
                return 'Промокод не действителен'
            case EnumCouponError.IncompatibleWithPersonalDiscountCoupon:
                return 'Промокод нельзя использовать вместе с персональной скидкой'
            default:
                return 'Такой промокод не найден или более не действителен!'
        }
    }


}    

